var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 120,
    viewBox: "0 0 296 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12748_6685)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M224.253 48.3153C224.725 63.6793 213.48 85.2758 201.163 93.885C170.834 115.081 115.826 121.706 71.9828 113.946C71.3189 113.831 70.6742 113.711 70.0249 113.57C69.9436 113.563 69.8577 113.535 69.7765 113.529C63.215 112.265 56.9002 110.556 50.8995 108.341C41.0876 104.727 32.1685 99.8384 24.641 93.4791C24.3271 93.2209 24.0323 92.9587 23.7376 92.6965C16.5205 86.3879 10.6129 78.6949 6.52751 69.4872C6.22127 68.7879 5.93883 68.1068 5.65639 67.4257C-5.5778 39.2418 9.12327 10.9983 38.2535 7.86452C64.9004 4.99582 73.8622 15.057 95.3735 19.5547C116.88 24.0302 142.254 14.6938 163.394 9.48445C170.635 7.69181 178.481 7.83151 183.671 8.27239C202.465 9.91489 223.407 20.7898 224.253 48.3153Z",
    fill: "#4182EC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.006 86.4265L67.3624 74.099C64.8545 73.7457 63.1237 71.4144 63.4769 68.9065L72.4489 8.25763C72.8021 5.74973 75.1334 4.01892 77.6413 4.37215L161.285 16.6997C163.793 17.053 165.524 19.3843 165.171 21.8922L156.234 82.5411C155.846 85.0843 153.514 86.8151 151.006 86.4265Z",
    fill: "url(#paint0_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.116 85.7154C153.222 86.0417 155.192 84.5912 155.522 82.4338C155.523 82.4333 155.523 82.4329 155.523 82.4324L164.458 21.7918C164.458 21.7912 164.458 21.7905 164.458 21.7899C164.756 19.6706 163.293 17.7092 161.185 17.4123L161.18 17.4116L77.5409 5.0847C77.5402 5.0846 77.5395 5.08449 77.5387 5.08439C75.4195 4.7871 73.4583 6.25001 73.1614 8.35799L73.1607 8.36294L64.1895 69.0069C64.1893 69.0077 64.1892 69.0086 64.1891 69.0094C63.892 71.1285 65.3549 73.0895 67.4628 73.3864L67.4673 73.387L151.116 85.7154ZM63.4769 68.9065L72.4489 8.25763C72.8021 5.74973 75.1334 4.01892 77.6413 4.37215L161.285 16.6997C163.793 17.053 165.524 19.3843 165.171 21.8922L156.234 82.5411C155.846 85.0843 153.514 86.8151 151.006 86.4265L67.3624 74.099C64.8545 73.7457 63.1237 71.4144 63.4769 68.9065Z",
    fill: "url(#paint1_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.073 79.1083L69.1821 89.6344C66.6742 89.9523 64.3783 88.1509 64.0604 85.643L56.4307 24.8528C56.1128 22.3449 57.9142 20.0489 60.4221 19.731L144.313 9.20487C146.821 8.88697 149.117 10.6884 149.435 13.1963L157.065 74.0218C157.383 76.4944 155.581 78.7904 153.073 79.1083Z",
    fill: "url(#paint2_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1821 89.6344L153.073 79.1083C155.581 78.7904 157.383 76.4944 157.065 74.0218L149.435 13.1963C149.117 10.6884 146.821 8.88697 144.313 9.20487L60.4221 19.731C57.9142 20.0489 56.1128 22.3449 56.4307 24.8528L64.0604 85.643C64.3783 88.1509 66.6742 89.9523 69.1821 89.6344ZM64.7743 85.5529C64.7743 85.5527 64.7743 85.553 64.7743 85.5529C65.043 87.6713 66.9831 89.1878 69.0916 88.9205L152.983 78.3944C152.983 78.3944 152.983 78.3944 152.983 78.3944C155.105 78.1252 156.617 76.1821 156.351 74.1136L156.351 74.1114L148.721 13.2868C148.453 11.1682 146.512 9.65145 144.404 9.91874L60.5126 20.4449C58.394 20.7134 56.8772 22.6536 57.1445 24.7623L64.7743 85.5529Z",
    fill: "url(#paint3_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.13 112.444L76.4743 99.8772C74.1641 99.4885 72.5945 96.9631 73.0016 94.2583L82.8238 27.5558C83.2309 24.851 85.4496 22.9418 87.7598 23.3306L164.415 35.8975C166.726 36.2862 168.295 38.8117 167.888 41.5165L158.066 108.219C157.659 110.924 155.476 112.798 153.13 112.444Z",
    fill: "url(#paint4_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0016 94.2583C72.5945 96.963 74.1641 99.4885 76.4743 99.8772L153.13 112.444C155.476 112.798 157.659 110.924 158.066 108.219L167.888 41.5165C168.295 38.8117 166.726 36.2862 164.415 35.8975L87.7598 23.3306C85.4496 22.9418 83.2309 24.851 82.8238 27.5558L73.0016 94.2583ZM164.251 36.8839C164.251 36.8838 164.25 36.8837 164.249 36.8836L87.5939 24.3167C85.9818 24.0454 84.1613 25.393 83.8129 27.7032C83.8128 27.7037 83.8127 27.7042 83.8126 27.7047L73.9905 94.4071C73.6436 96.7119 74.997 98.614 76.6395 98.891C76.6392 98.8909 76.6397 98.891 76.6395 98.891L153.279 111.455C153.281 111.456 153.283 111.456 153.285 111.456C154.952 111.704 156.731 110.367 157.077 108.071C157.077 108.071 157.077 108.07 157.077 108.07L166.899 41.3708L166.899 41.3676C167.246 39.0633 165.893 37.1615 164.251 36.8839Z",
    fill: "url(#paint5_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.978 44.2407L84.6882 32.1957C83.6991 30.8888 82.1449 30.1117 80.5908 30.1117H56.5361C53.9575 30.1117 52.0854 32.2311 52.368 34.8096L53.357 44.2407L53.3924 44.594L60.2449 109.87C60.5275 112.449 62.8235 114.533 65.402 114.533H161.02C163.599 114.533 165.471 112.449 165.188 109.87L158.729 53.6691C158.447 51.0906 148.458 44.2407 145.88 44.2407H93.978Z",
    fill: "url(#paint6_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4727 45.2687L83.8684 32.8161C83.0671 31.7571 81.8121 31.1397 80.5908 31.1397H56.5361C54.5814 31.1397 53.1727 32.7156 53.3899 34.6976L53.3904 34.7024L54.3799 44.1384L54.4147 44.4866L54.4152 44.4917L61.2668 109.758C61.2669 109.759 61.267 109.76 61.267 109.76C61.4946 111.826 63.3576 113.505 65.402 113.505H161.02C162.985 113.505 164.381 111.955 164.167 109.985C164.167 109.984 164.167 109.983 164.167 109.982L157.708 53.7811C157.701 53.7211 157.636 53.5061 157.361 53.1149C157.104 52.7487 156.726 52.3172 156.242 51.8392C155.277 50.8851 153.968 49.8224 152.569 48.8251C151.172 47.8291 149.713 46.9185 148.459 46.262C147.831 45.9334 147.27 45.6765 146.804 45.5043C146.315 45.3234 146.016 45.2687 145.88 45.2687H93.4727ZM53.3924 44.594L53.357 44.2407L52.368 34.8096C52.0854 32.2311 53.9575 30.1117 56.5361 30.1117H80.5908C82.1449 30.1117 83.6991 30.8888 84.6882 32.1957L93.978 44.2407H145.88C148.458 44.2407 158.447 51.0906 158.729 53.6691L165.188 109.87C165.471 112.449 163.599 114.533 161.02 114.533H65.402C62.8235 114.533 60.5275 112.449 60.2449 109.87L53.3924 44.594Z",
    fill: "url(#paint7_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.711 92.9247C162.54 87.3327 163.787 79.524 163.787 72.8526L160.382 72.8526C160.382 79.2344 155.688 85.3547 151.127 89.8673C146.565 94.3799 140.378 96.915 133.927 96.915C127.476 96.915 121.289 94.3799 116.727 89.8673C112.166 85.3547 107.421 70.0916 107.421 63.7099L117.684 45.1688C106.6 52.8092 103.304 63.2775 103.304 72.8526C103.387 81.2267 107.075 88.3646 109.364 91.5311C114.806 99.0569 126.728 104 134.647 104C142.473 104 150.673 101.234 156.269 95.8228L162.203 100.446L161.798 94.8426L158.711 92.9247Z",
    fill: "#162264",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.155 48.6651C131.578 45.1912 120.67 50.4673 116.76 52.5641L115.621 48.8238L123.779 45.6713L131.964 42.5197L140.889 43.2739L150.569 46.9195L161.466 61.1249V70.9432L159.548 74.7056C159.548 59.6953 151.835 51.8444 142.155 48.6651Z",
    fill: "#000C4D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.924 107.517C193.897 104.527 193.039 100.545 190.111 98.6119L160.723 79.0525L153.642 89.822L183.03 109.382C186.009 111.304 190.002 110.496 191.924 107.517Z",
    fill: "url(#paint8_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.793 91.3196L162.925 80.4996L169.964 85.1397C169.964 85.1397 166.059 84.643 163.668 88.2706C161.277 91.8981 162.833 95.9596 162.833 95.9596L155.793 91.3196Z",
    fill: "url(#paint9_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M140.38 95.2472C126.332 98.2429 112.515 89.2828 109.519 75.2344C106.523 61.1859 115.483 47.3689 129.532 44.3732C143.58 41.3775 157.397 50.3376 160.393 64.386C163.389 78.4345 154.429 92.2515 140.38 95.2472Z",
    fill: "url(#paint10_radial_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.879 53.3645C118.973 39.543 137.59 35.6893 151.463 44.7727C165.284 53.867 169.138 72.4835 160.054 86.3561C150.96 100.178 132.344 104.031 118.471 94.948C104.638 85.8026 100.785 67.1861 109.879 53.3645ZM155.626 83.4107C163.108 72.0205 159.958 56.6715 148.568 49.19C137.178 41.7085 121.829 44.8576 114.347 56.2478C106.866 67.638 110.015 82.987 121.405 90.4686C132.795 97.9501 148.093 94.8119 155.626 83.4107Z",
    fill: "url(#paint11_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.731 78.3289L131.496 71.7295L124.901 64.9598C123.965 63.9805 123.987 62.4478 124.944 61.4898C125.922 60.5531 127.454 60.5744 128.411 61.5324L135.006 68.3021L141.771 61.7027C142.749 60.766 144.281 60.7873 145.238 61.7453C146.174 62.7246 146.153 64.2573 145.196 65.2153L138.431 71.8147L145.025 78.5843C145.961 79.5636 145.94 81.0964 144.983 82.0544C144.004 82.9911 142.473 82.9698 141.515 82.0118L134.921 75.2421L128.156 81.8415C127.199 82.7782 125.646 82.7569 124.688 81.7989C123.731 80.8196 123.753 79.2656 124.731 78.3289Z",
    fill: "#14205C",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.731 76.7531L131.496 70.1537L124.901 63.3839C123.965 62.4046 123.987 60.8719 124.944 59.9139C125.922 58.9773 127.454 58.9986 128.411 59.9566L135.006 66.7262L141.771 60.1268C142.749 59.1901 144.281 59.2115 145.238 60.1694C146.174 61.1487 146.153 62.6814 145.196 63.6394L138.431 70.2388L145.025 77.0085C145.961 77.9877 145.94 79.5206 144.983 80.4785C144.004 81.4152 142.473 81.3939 141.515 80.4359L134.921 73.6663L128.156 80.2657C127.199 81.2024 125.646 81.181 124.688 80.223C123.731 79.2438 123.753 77.6898 124.731 76.7531Z",
    fill: "url(#paint12_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12748_6685)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.1514,
    height: 19.3024,
    rx: 3.86048,
    transform: "matrix(-1 0 0 1 74.71 50.05)",
    fill: "url(#paint13_linear_12748_6685)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4191,
    y: 53.9105,
    width: 10.9541,
    height: 10.9541,
    rx: 1.98218,
    fill: "url(#paint14_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0253 60.5347V60.3905C32.0253 60.0602 32.0513 59.797 32.1034 59.6008C32.1554 59.4046 32.2325 59.2475 32.3346 59.1294C32.4367 59.0092 32.5618 58.9011 32.7099 58.8051C32.8381 58.721 32.9522 58.6399 33.0523 58.5618C33.1544 58.4838 33.2344 58.4007 33.2925 58.3126C33.3525 58.2245 33.3826 58.1244 33.3826 58.0123C33.3826 57.9122 33.3585 57.8241 33.3105 57.7481C33.2625 57.672 33.1974 57.613 33.1153 57.5709C33.0332 57.5289 32.9422 57.5079 32.8421 57.5079C32.734 57.5079 32.6339 57.5329 32.5418 57.5829C32.4517 57.633 32.3786 57.702 32.3226 57.7901C32.2685 57.8782 32.2415 57.9803 32.2415 58.0964H30.7041C30.7081 57.656 30.8082 57.2987 31.0044 57.0244C31.2005 56.7481 31.4608 56.546 31.7851 56.4178C32.1094 56.2877 32.4657 56.2227 32.8541 56.2227C33.2825 56.2227 33.6648 56.2857 34.0011 56.4118C34.3375 56.5359 34.6027 56.7241 34.7969 56.9764C34.9911 57.2266 35.0882 57.5399 35.0882 57.9162C35.0882 58.1585 35.0461 58.3717 34.962 58.5558C34.88 58.738 34.7648 58.8991 34.6167 59.0393C34.4706 59.1774 34.2994 59.3035 34.1032 59.4176C33.9591 59.5017 33.838 59.5888 33.7399 59.6789C33.6418 59.767 33.5677 59.868 33.5177 59.9822C33.4676 60.0943 33.4426 60.2304 33.4426 60.3905V60.5347H32.0253ZM32.758 62.5525C32.5258 62.5525 32.3266 62.4715 32.1604 62.3093C31.9963 62.1452 31.9152 61.946 31.9172 61.7118C31.9152 61.4836 31.9963 61.2884 32.1604 61.1262C32.3266 60.9641 32.5258 60.883 32.758 60.883C32.9782 60.883 33.1724 60.9641 33.3405 61.1262C33.5107 61.2884 33.5968 61.4836 33.5988 61.7118C33.5968 61.8679 33.5557 62.01 33.4756 62.1382C33.3976 62.2643 33.2955 62.3654 33.1694 62.4414C33.0432 62.5155 32.9061 62.5525 32.758 62.5525Z",
    fill: "url(#paint15_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3035,
    y: 55.4261,
    width: 15.7651,
    height: 2.72247,
    rx: 0.991088,
    fill: "url(#paint16_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3035,
    y: 60.6263,
    width: 30.5461,
    height: 2.72247,
    rx: 0.991088,
    fill: "url(#paint17_linear_12748_6685)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12748_6685)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.1514,
    height: 19.3024,
    rx: 3.86048,
    transform: "matrix(-1 0 0 1 85.1514 72.05)",
    fill: "url(#paint18_linear_12748_6685)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.8605,
    y: 75.9105,
    width: 10.9541,
    height: 10.9541,
    rx: 1.98218,
    fill: "url(#paint19_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4667 82.5347V82.3905C42.4667 82.0602 42.4927 81.797 42.5448 81.6008C42.5968 81.4046 42.6739 81.2475 42.776 81.1294C42.8781 81.0092 43.0032 80.9011 43.1513 80.8051C43.2795 80.721 43.3936 80.6399 43.4937 80.5618C43.5958 80.4838 43.6758 80.4007 43.7339 80.3126C43.7939 80.2245 43.824 80.1244 43.824 80.0123C43.824 79.9122 43.7999 79.8241 43.7519 79.7481C43.7039 79.672 43.6388 79.613 43.5567 79.5709C43.4746 79.5289 43.3836 79.5079 43.2835 79.5079C43.1754 79.5079 43.0753 79.5329 42.9832 79.5829C42.8931 79.633 42.82 79.702 42.764 79.7901C42.7099 79.8782 42.6829 79.9803 42.6829 80.0964H41.1455C41.1495 79.656 41.2496 79.2987 41.4458 79.0244C41.6419 78.7481 41.9022 78.546 42.2265 78.4178C42.5508 78.2877 42.9071 78.2227 43.2955 78.2227C43.7239 78.2227 44.1062 78.2857 44.4425 78.4118C44.7789 78.5359 45.0441 78.7241 45.2383 78.9764C45.4325 79.2266 45.5296 79.5399 45.5296 79.9162C45.5296 80.1585 45.4875 80.3717 45.4034 80.5558C45.3214 80.738 45.2063 80.8991 45.0581 81.0393C44.912 81.1774 44.7408 81.3035 44.5446 81.4176C44.4005 81.5017 44.2794 81.5888 44.1813 81.6789C44.0832 81.767 44.0091 81.868 43.9591 81.9822C43.909 82.0943 43.884 82.2304 43.884 82.3905V82.5347H42.4667ZM43.1994 84.5525C42.9672 84.5525 42.768 84.4715 42.6018 84.3093C42.4377 84.1452 42.3566 83.946 42.3586 83.7118C42.3566 83.4836 42.4377 83.2884 42.6018 83.1262C42.768 82.9641 42.9672 82.883 43.1994 82.883C43.4196 82.883 43.6138 82.9641 43.7819 83.1262C43.9521 83.2884 44.0382 83.4836 44.0402 83.7118C44.0382 83.8679 43.9971 84.01 43.9171 84.1382C43.839 84.2643 43.7369 84.3654 43.6108 84.4414C43.4847 84.5155 43.3475 84.5525 43.1994 84.5525Z",
    fill: "url(#paint20_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.7449,
    y: 77.4261,
    width: 15.7651,
    height: 2.72247,
    rx: 0.991088,
    fill: "url(#paint21_linear_12748_6685)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.7449,
    y: 82.6263,
    width: 30.5461,
    height: 2.72247,
    rx: 0.991088,
    fill: "url(#paint22_linear_12748_6685)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12748_6685",
    x: 21.6297,
    y: 49.0856,
    width: 58.8668,
    height: 27.0178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.92885,
    dy: 2.89328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92885
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.130752 0 0 0 0 0.15853 0 0 0 0 0.219642 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12748_6685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12748_6685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12748_6685",
    x: 32.0711,
    y: 71.0856,
    width: 58.8668,
    height: 27.0178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.92885,
    dy: 2.89328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92885
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.130752 0 0 0 0 0.15853 0 0 0 0 0.219642 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12748_6685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12748_6685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12748_6685",
    x1: 100.389,
    y1: -24.2745,
    x2: 82.1009,
    y2: 112.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202901,
    stopColor: "#A1B3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47265,
    stopColor: "#1D3882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12748_6685",
    x1: 66.4986,
    y1: -0.0444544,
    x2: 131.225,
    y2: 70.2618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6B6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5167A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12748_6685",
    x1: 74.6281,
    y1: -38.3403,
    x2: 89.7749,
    y2: 108.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142989,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373896,
    stopColor: "#E4EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592959,
    stopColor: "#4F71D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12748_6685",
    x1: 165.135,
    y1: 10.7614,
    x2: 106.843,
    y2: 74.5801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DADDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408204,
    stopColor: "#CFD6E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12748_6685",
    x1: 97.2787,
    y1: 17.32,
    x2: 85.6041,
    y2: 131.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430736,
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12748_6685",
    x1: 172.826,
    y1: 26.7505,
    x2: 118.876,
    y2: 77.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12748_6685",
    x1: 121.896,
    y1: 109.219,
    x2: 66.885,
    y2: 33.0307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164324,
    stopColor: "#122D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690489,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12748_6685",
    x1: 52.3398,
    y1: 27.6656,
    x2: 164.141,
    y2: 100.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EBDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377456,
    stopColor: "#405EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234194"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12748_6685",
    x1: 203.11,
    y1: 86.9555,
    x2: 175.309,
    y2: 108.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F3C869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA11B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12748_6685",
    x1: 160.043,
    y1: 86.4266,
    x2: 166.844,
    y2: 90.8783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B6E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2AA2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A726"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_12748_6685",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.53 32.1371) rotate(108.29) scale(64.3682 64.3682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192855"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12748_6685",
    x1: 146.816,
    y1: 16.7786,
    x2: 136.488,
    y2: 86.4465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F3C869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA11B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12748_6685",
    x1: 134.955,
    y1: 58.1537,
    x2: 123.207,
    y2: 77.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#EF3C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C83728"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12748_6685",
    x1: 18.573,
    y1: -6.71986,
    x2: 36.142,
    y2: 31.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724203,
    stopColor: "#B3C0E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12748_6685",
    x1: 35.0634,
    y1: 74.681,
    x2: 1.58481,
    y2: 62.5431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58194,
    stopColor: "#C3CDEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12748_6685",
    x1: 30.3608,
    y1: 68.5047,
    x2: 25.6673,
    y2: 58.1904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.320396,
    stopColor: "#A2B5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12748_6685",
    x1: 51.3052,
    y1: 60.5883,
    x2: 41.2244,
    y2: 39.4236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#D5DEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12748_6685",
    x1: 61.6201,
    y1: 65.7885,
    x2: 55.6007,
    y2: 41.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#D5DEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12748_6685",
    x1: 18.573,
    y1: -6.71986,
    x2: 36.142,
    y2: 31.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724203,
    stopColor: "#B3C0E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12748_6685",
    x1: 45.5048,
    y1: 96.681,
    x2: 12.0262,
    y2: 84.5431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608161,
    stopColor: "#C2CDEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12748_6685",
    x1: 40.8023,
    y1: 90.5047,
    x2: 36.1087,
    y2: 80.1904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.320396,
    stopColor: "#A2B5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12748_6685",
    x1: 61.7466,
    y1: 82.5883,
    x2: 51.6658,
    y2: 61.4236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#BAC6E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12748_6685",
    x1: 72.0615,
    y1: 87.7885,
    x2: 66.0421,
    y2: 63.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#BAC6E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12748_6685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFound);
export default __webpack_public_path__ + "static/media/no-found.58add2eb315890f1e068e9c86e897663.svg";
export { ForwardRef as ReactComponent };